module.exports = __webpack_public_path__ + "static/media/oggie.1c665bf8.jpg";